// @ts-nocheck
/* eslint-disable */
const DOT = '.';
const SLASH = '/';
const EMPTY_STRING = '';
// const PIPE = '\\|';
const PIPE = '|';
const DOLLARES = '\\$';
const NO_FEED = 'no_feed';

function getAttributeInLevel(attributeList, level) {
    let result = '';
    let currentLevel;
    let bestLevel = -1;
    for (let index10940 = 0; index10940 < attributeList.length; index10940++) {
        const attr = attributeList[index10940];

        if (attr != null && !(/* isEmpty */ (attr.length === 0))) {
            try {
                currentLevel = /* parseInt */ parseInt(
                    attr.substring(0, 1),
                    10,
                );
                if (currentLevel >= level) {
                    return attr;
                }
                if (currentLevel >= bestLevel) {
                    result = attr;
                    bestLevel = currentLevel;
                }
            } catch (e) {}
        }
    }
    return result;
}

function getTaxonomyValue(values, taxonomyLevel, splitter) {
    return getAttributeInLevel(values, taxonomyLevel).split(splitter);
}

function getTaxonomySplitter(value) {
    if (/* isEmpty */ value.length === 0 || value.length < 2) {
        return EMPTY_STRING;
    }
    const splitter = value.substring(1, 2);
    switch (splitter) {
        case '.' /* DOT */:
            // return ESC_DOT;
            return DOT;
        case '/' /* SLASH */:
            // return ESC_SLASH;
            return SLASH;
        default:
            return EMPTY_STRING;
    }
}

function mapValuesToNames(parameters, parameterNames, bestValue) {
    for (let i = 1; i < bestValue.length; i++) {
        {
            if (i > parameterNames.length) {
                break;
            }
            const name = parameterNames[i - 1];
            const value = bestValue[i];
            const parametersValue = [];
            /* add */ parametersValue.push(value) > 0;
            /* put */ parameters[name] = parametersValue;
        }
    }
    return parameters;
}

/**
 * Example:
 * ;;make;;;;;;copyIfNot:model|make_split;
 *
 * Splits a taxonomic value (make=0.123) into a non taxonomic value(make_split=123), only if the parameter map does
 * not contain a parameter on a lower taxonomic level (model)
 * @param {*} parameters
 * @param {string} rule
 * @param {string} key
 * @return {*}
 */
function ruleCopyIfNot(parameters, rule, key) {
    const values = /* get */ ((m, k) => (m[k] === undefined ? null : m[k]))(
        parameters,
        key,
    );
    if (/* isEmpty */ values.length === 0 || /* isEmpty */ rule.length === 0) {
        return parameters;
    }
    const parameterNames = rule.split(PIPE);
    if (
        parameterNames.length > 1 &&
        !(/* containsKey */ parameters.hasOwnProperty(parameterNames[0]))
    ) {
        // @ts-ignore
        const realParameterNames = ((s) => {
            const a = [];
            while (s-- > 0) a.push(null);
            return a;
        })(parameterNames.length - 1);
        /* arraycopy */ ((srcPts, srcOff, dstPts, dstOff, size) => {
            if (srcPts !== dstPts || dstOff >= srcOff + size) {
                while (--size >= 0) dstPts[dstOff++] = srcPts[srcOff++];
            } else {
                const tmp = srcPts.slice(srcOff, srcOff + size);
                for (let i = 0; i < size; i++) dstPts[dstOff++] = tmp[i];
            }
        })(parameterNames, 1, realParameterNames, 0, realParameterNames.length);
        const splitter = getTaxonomySplitter(/* get */ values[0]);
        if (
            !(
                /* equals */ ((o1, o2) => {
                    if (o1 && o1.equals) {
                        return o1.equals(o2);
                    }
                    return o1 === o2;
                })(splitter, EMPTY_STRING)
            )
        ) {
            const taxonomyLevel = parameterNames.length;
            const bestValue = getTaxonomyValue(values, taxonomyLevel, splitter);
            parameters = mapValuesToNames(
                parameters,
                realParameterNames,
                bestValue,
            );
        } else {
            const parametersValue = [];
            /* add */ parametersValue.push(/* get */ values[0]) > 0;
            /* put */ parameters[parameterNames[1]] = parametersValue;
        }
    }
    return parameters;
}

function ruleSplitInto(parameters, rule, key) {
    const values = /* get */ ((m, k) => (m[k] === undefined ? null : m[k]))(
        parameters,
        key,
    );
    if (!values || values.length === 0) {
        return parameters;
    }
    const splitter = getTaxonomySplitter(/* get */ values[0]);
    if (
        !(
            /* equals */ ((o1, o2) => {
                if (o1 && o1.equals) {
                    return o1.equals(o2);
                }
                return o1 === o2;
            })(splitter, EMPTY_STRING)
        )
    ) {
        const parameterNames = rule.split(PIPE);
        const taxonomyLevel = parameterNames.length;
        const bestValue = getTaxonomyValue(values, taxonomyLevel, splitter);
        parameters = mapValuesToNames(parameters, parameterNames, bestValue);
    }
    return parameters;
}

function getRuleParameterMap(parameterArray) {
    const parameterMap = {};
    if (parameterArray.length > 1) {
        for (
            let index10945 = 0;
            index10945 < parameterArray.length;
            index10945++
        ) {
            const parameters = parameterArray[index10945];
            {
                const parameter = parameters.split(DOLLARES);
                if (parameter.length > 1)
                    /* put */ parameterMap[parameter[0]] = parameter[1];
            }
        }
    }
    return parameterMap;
}

function ruleReplaceAndNoFeed(parameters, rule, key) {
    const values = ((m, k) => (m[k] === undefined ? null : m[k]))(
        parameters,
        key,
    );
    if (/* isEmpty */ values.length === 0 || /* isEmpty */ rule.length === 0) {
        return parameters;
    }
    const ruleParameters = rule.split(PIPE);
    const ruleParameterMap = getRuleParameterMap(ruleParameters);
    if (
        /* containsKey */ ruleParameterMap.hasOwnProperty(
            /* get */ values[0].toLowerCase(),
        )
    ) {
        const parameterValue = [];
        /* add */ parameterValue.push(
            /* get */ ((m, k) => (m[k] === undefined ? null : m[k]))(
                ruleParameterMap,
                /* get */ values[0].toLowerCase(),
            ),
        ) > 0;
        parameters.replace(key, parameterValue);
        /* put */ parameters[NO_FEED] = parameterValue;
    }
    return parameters;
}

export function preProcessParameters(rules, parameters) {
    Object.keys(rules).forEach((key) => {
        if (key in parameters) {
            const rule = rules[key];
            Object.keys(rule).forEach((preRule) => {
                switch (preRule) {
                    case 'splitInto':
                        parameters = ruleSplitInto(
                            parameters,
                            rule[preRule],
                            key,
                        );
                        break;
                    case 'copyIfNot':
                        parameters = ruleCopyIfNot(
                            parameters,
                            rule[preRule],
                            key,
                        );
                        break;
                    case 'replaceAndNoFeed':
                        parameters = ruleReplaceAndNoFeed(
                            parameters,
                            rule[preRule],
                            key,
                        );
                        break;

                    default:
                        break;
                }
            });
        }
    });

    return parameters;
}
